<template>
    <ul class="navbar-nav">
        <slot></slot>
        <li class="nav-item" v-for="icon in [...additionalIcons, ...icons]" :key="icon.icon[1]">
            <a class="nav-link" target="_blank" :href="icon.link" @mouseover="$emit('hover', icon)"
                @mouseout="$emit('hover', null)">
                <fa-icon :icon="icon.icon" />
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    props: {
        additionalIcons: { type: Array, default: () => [] }
    },
    data() {
        return {
            icons: [/*{
                link: 'https://www.xing.com/profile/Michael_Feinbier/',
                icon: 'fa-xing',
                title: 'XING'
            },*/{
                    link: 'https://www.linkedin.com/in/michael-feinbier',
                    icon: ['fab', 'linkedin'],
                    title: 'LinkedIn'
                }, {
                    link: 'https://github.com/michaelfeinbier',
                    icon: ['fab', 'github'],
                    title: 'Github'
                }, {
                    link: 'https://twitter.com/denkweite',
                    icon: ['fab', 'twitter'],
                    title: 'Twitter',
                    subtitle: '@denkweite'
                },]
        }
    }
}
</script>
